/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GssOccasionPersonTeaserProfilePhotoUrl } from './gssOccasionPersonTeaserProfilePhotoUrl';
import type { GssOccasionPersonTeaserConnectionDirection } from './gssOccasionPersonTeaserConnectionDirection';
import type { GssOccasionPersonTeaserConnectionStatus } from './gssOccasionPersonTeaserConnectionStatus';
import type { GssOccasionPersonTeaserConnectionId } from './gssOccasionPersonTeaserConnectionId';

/**
 * Registered classmate teaser — first name and photo only; no contacts.
 */
export interface GssOccasionPersonTeaser {
  userId: string;
  firstName: string;
  profilePhotoUrl?: GssOccasionPersonTeaserProfilePhotoUrl;
  connectionDirection?: GssOccasionPersonTeaserConnectionDirection;
  connectionStatus?: GssOccasionPersonTeaserConnectionStatus;
  connectionId?: GssOccasionPersonTeaserConnectionId;
}
